import { createLazySingleton } from '@/utils/singleton/createLazySingleton';
import { AppRoleGraphQLService } from './app-role.service';
import { AppUserGraphQLService } from './app-user.service';
import { AssigneeGraphQLService } from './assignee.service';
import { BusinessTripFormGraphQLService } from './business-trip-form.service';
import { ComponentCategoryGraphQLService } from './component-category.service';
import { ComponentDetailGraphQLService } from './component-detail.service';
import { ComponentGroupGraphQLService } from './component-group.service';
import { ComponentRequisitionMetricGraphQLService } from './component-requisition-metric.service';
import { ComponentRequisitionGraphQLService } from './component-requisition.service';
import { ComponentSKUGraphQLService } from './component-sku.service';
import { ComponentTypeGraphQLService } from './component-type.service';
import { CustomerAccountGraphQLService } from './customer-account.service';
import { CustomerContactGraphQLService } from './customer-contact.service';
import { CustomerGraphQLService } from './customer.service';
import { DeviceGroupGraphQLService } from './device-group.service';
import { DeviceModelGraphQLService } from './device-model.service';
import { DeviceSKUGraphQLService } from './device-sku.service';
import { DeviceTypeGraphQLService } from './device-type.service';
import { DeviceGraphQLService } from './device.service';
import { DynamicTaskGraphQLService } from './dynamic-task.service';
import { DynamicTicketGraphQLService } from './dynamic-ticket.service';
import { ErrorDetailTaskCheckGraphQLService } from './error-detail-task-check.service';
import { ErrorDetailGraphQLService } from './error-detail.service';
import { ErrorTypeGraphQLService } from './error-type.service';
import { PriorityGraphQLService } from './priority.service';
import { QualityManagementGraphQLService } from './quality-management.service';
import { ReminderScheduleGraphQLService } from './reminder-schedule.service';
import { SeverityLevelGraphQLService } from './severity-level.service';
import { TaskCheckRepeatGraphQLService } from './task-check-repeat.service';
import { TaskCheckTypeGraphQLService } from './task-check-type.service';
import { TaskCheckGraphQLService } from './task-check.service';
import { TemplateCheckGraphQLService } from './template-check.service';
import { TicketTypeGraphQLService } from './ticket-type.service';
import { TicketGraphQLService } from './ticket.service';
import { UsageTypeGraphQLService } from './usage-type.service';
import { ViolationDetailTaskCheckGraphQLService } from './violation-detail-task-check.service';
import { ViolationDetailGraphQLService } from './violation-detail.service';
import { ViolationTypeGraphQLService } from './violation-type.service';

export const ticketGraphQLService = createLazySingleton(TicketGraphQLService);

export const assigneeGraphQLService = createLazySingleton(
    AssigneeGraphQLService
);

export const taskCheckGraphQLService = createLazySingleton(
    TaskCheckGraphQLService
);

export const businessTripFormGraphQLService = createLazySingleton(
    BusinessTripFormGraphQLService
);

export const deviceGraphQLService = createLazySingleton(DeviceGraphQLService);

export const customerGraphQLService = createLazySingleton(
    CustomerGraphQLService
);

export const deviceSKUGraphQLService = createLazySingleton(
    DeviceSKUGraphQLService
);

export const errorDetailTaskCheckGraphQLService = createLazySingleton(
    ErrorDetailTaskCheckGraphQLService
);

export const errorTypeGraphQLService = createLazySingleton(
    ErrorTypeGraphQLService
);

export const severityLevelGraphQLService = createLazySingleton(
    SeverityLevelGraphQLService
);

export const qualityManagementGraphQLService = createLazySingleton(
    QualityManagementGraphQLService
);

export const componentRequisitionGraphQLService = createLazySingleton(
    ComponentRequisitionGraphQLService
);

export const appUserGraphQLService = createLazySingleton(AppUserGraphQLService);

export const deviceTypeGraphQLService = createLazySingleton(
    DeviceTypeGraphQLService
);

export const deviceGroupGraphQLService = createLazySingleton(
    DeviceGroupGraphQLService
);

export const deviceModelGraphQLService = createLazySingleton(
    DeviceModelGraphQLService
);

export const componentCategoryGraphQLService = createLazySingleton(
    ComponentCategoryGraphQLService
);

export const componentTypeGraphQLService = createLazySingleton(
    ComponentTypeGraphQLService
);

export const componentGroupGraphQLService = createLazySingleton(
    ComponentGroupGraphQLService
);

export const componentSKUGraphQLService = createLazySingleton(
    ComponentSKUGraphQLService
);

export const templateCheckGraphQLService = createLazySingleton(
    TemplateCheckGraphQLService
);

export const ticketTypeGraphQLService = createLazySingleton(
    TicketTypeGraphQLService
);

export const taskCheckTypeGraphQLService = createLazySingleton(
    TaskCheckTypeGraphQLService
);

export const usageTypeGraphQLService = createLazySingleton(
    UsageTypeGraphQLService
);

export const errorDetailGraphQLService = createLazySingleton(
    ErrorDetailGraphQLService
);

export const violationDetailGraphQLService = createLazySingleton(
    ViolationDetailGraphQLService
);

export const violationTypeGraphQLService = createLazySingleton(
    ViolationTypeGraphQLService
);

export const appRoleGraphQLService = createLazySingleton(AppRoleGraphQLService);

export const violationDetailTaskCheckGraphQLService = createLazySingleton(
    ViolationDetailTaskCheckGraphQLService
);

export const componentRequisitionMetricGraphQLService = createLazySingleton(
    ComponentRequisitionMetricGraphQLService
);

export const reminderScheduleGraphQLService = createLazySingleton(
    ReminderScheduleGraphQLService
);

export const taskCheckRepeatGraphQLService = createLazySingleton(
    TaskCheckRepeatGraphQLService
);

export const componentDetailGraphQLService = createLazySingleton(
    ComponentDetailGraphQLService
);

export const customerAccountGraphQLService = createLazySingleton(
    CustomerAccountGraphQLService
);

export const customerContactGraphQLService = createLazySingleton(
    CustomerContactGraphQLService
);

export const priorityGraphQLService = createLazySingleton(
    PriorityGraphQLService
);

export const dynamicTicketDynamicGraphQLService = createLazySingleton(
    DynamicTicketGraphQLService
);
export const dynamicTaskGraphQLService = createLazySingleton(
    DynamicTaskGraphQLService
);
